module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_4_5.e0450ed8.png";